import PropTypes from "prop-types"
import React from "react"

import Article from "areas/helpdesk/article"
import fetchCollectionData from "hoc/helpdesk/fetch-collection-results"

const WrappedArticle = ({
  helpdeskArticle,
  helpdeskRelatedArticles,
  match,
  staticContext,
}) => {
  return (
    <Article
      helpdeskArticle={helpdeskArticle}
      helpdeskRelatedArticles={helpdeskRelatedArticles}
      match={match}
      staticContext={staticContext}
    />
  )
}

WrappedArticle.propTypes = {
  helpdeskArticle: PropTypes.object,
  helpdeskRelatedArticles: PropTypes.array,
  match: PropTypes.object,
  staticContext: PropTypes.object,
}

export default fetchCollectionData(WrappedArticle)
